module.exports = __webpack_public_path__ + "img/35-02.b8bbad20.png";